/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiCloudWatchGet } from '../fn/cloud-watch/api-cloud-watch-get';
import { ApiCloudWatchGet$Params } from '../fn/cloud-watch/api-cloud-watch-get';

@Injectable({ providedIn: 'root' })
export class CloudWatchService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiCloudWatchGet()` */
  static readonly ApiCloudWatchGetPath = '/api/CloudWatch';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCloudWatchGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCloudWatchGet$Response(params?: ApiCloudWatchGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiCloudWatchGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCloudWatchGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCloudWatchGet(params?: ApiCloudWatchGet$Params, context?: HttpContext): Observable<void> {
    return this.apiCloudWatchGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
